module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp1_8004.37b29652.png";